import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/novos'
  },
  {
    path: '/',
    redirect: '/novos'
  }, 
  {
    path: '/novos',
    name: 'Novos',
  },
  {
    path: '/atrasados',
    name: 'Atrasados',
  }, 
  {
    path: '/andamento',
    name: 'Andamento',
  }, {
    path: '/concluidos',
    name: 'Concluídos',
  }, {
    path: '/total',
    name: 'Total',
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.name

  next()
});

export default router
